import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { watch } from "vue";
import { useStore } from "vuex";

export default /*#__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

const store = useStore();

const changIco = (link) => {
  let $favicon = document.querySelector('link[rel="icon"]');
  if ($favicon !== null) {
    $favicon.href = link;
  } else {
    $favicon = document.createElement("link");
    $favicon.rel = "icon";
    $favicon.href = link;
    document.head.appendChild($favicon);
  }
};
const changDescription = (text) => {
  let meta = document.querySelector('meta[name="description"]');
  if (meta !== null) {
    meta.content = text;
  } else {
    meta = document.createElement("meta");
    meta.name = "description";
    meta.content = text;
    document.head.appendChild(meta);
  }
};
const changKeywords = (text) => {
  let meta = document.querySelector('meta[name="keywords"]');
  if (meta !== null) {
    meta.content = text;
  } else {
    meta = document.createElement("meta");
    meta.name = "keywords";
    meta.concontentt = text;
    document.head.appendChild(meta);
  }
};
watch(
  () => store?.state?.prosperityObj,
  (val) => {
    // 动态修改网站图标
    changIco(val.ico);
    changKeywords(val.keywords);
    changDescription(val.description);
    document.title = val.title;
  },
  { immediate: true }
);

// 盛世繁华和悬浮窗数据
store.dispatch("getProsperity");
store.dispatch("getImageObj");

return (_ctx: any,_cache: any) => {
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createBlock(_component_router_view))
}
}

})